import { render, staticRenderFns } from "./agentForm.vue?vue&type=template&id=f061ab84&scoped=true"
import script from "./agentForm.vue?vue&type=script&lang=js"
export * from "./agentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f061ab84",
  null
  
)

export default component.exports